import Accept from '@/pages/dashboard/settings/Accept';
import Join from '@/pages/joinTeam/Join';
import JoinSuccessErrorMessage from '@/pages/joinTeam/JoinSuccessErrorMessage';
import { Route, Routes } from 'react-router';
import { RequireAuth } from './privateRoute';


const JoinTeam = () => {
	return (
		<Routes>
			<Route path={'/invite/join/:token'} element={<Join />} />
			<Route path={'/invite/fallback'} element={<JoinSuccessErrorMessage />} />
		</Routes>
	);
};

export default JoinTeam;

